import React from 'react';
import LoginForm from '../components/LoginForm';
import Logo from "../../../components/shared/Logo";
import {useNavigate} from "react-router-dom";
import Header from "../../../layouts/Header";
import LoginWithInvite from "../components/LoginWithInvite";


const LoginPage = () => {
    const navigate = useNavigate();
    const config = window.APP_CONFIG;
    window.localStorage.removeItem("type")

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(token) {
            if(window.localStorage.getItem("needRegistration")){
                navigate('/register');
                return;
            }
            navigate('/home');
        }
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)
    }, [navigate]);

    return (
        <div className="container-fluid  justify-content-center vertical-center mobile-size-option">
            <Header title='ورود به سامانه' hasBack={true} transparent={0}/>
            <div className="row">
                <div className="col-12 text-center">
                    <Logo size={100} />
                </div>
                <div className="col-12 mt-5">
                    <div className="row">

                        <div className="col-12 my-2 text-end text-small-1 text-muted pe-4  ">
                            <h5 className="mb-2 text-center">سلام. خوش آمدید 👋</h5>
                            <p className="mb-4 mt-4 text-small-1 text-muted text-center">
                                <span className='text-muted fw-bold'>شما به سامانه
                                    &nbsp;
                                    {config.title}
                                    &nbsp;
                                    دعوت شده اید.</span>
                                <br/>
                                
                                برای ورود به سامانه لطفا شماره همراه خود را وارد کنید
                            </p>

                        </div>
                        <div className="col-12">
                            <LoginWithInvite/>
                        </div>
                        <div className="col-12">
                            <p className="text-caption  text-muted mt-4 text-small-3 text-center">
                            ورود شما به معنای پذیرش
                                <span
                                    className="mx-1 d-inline-block text-primary"
                                    onClick={() => navigate('/contents/قوانین')}
                                >
                                قوانین و مقررات
                                    &nbsp;
                                    {config.title}
                            </span>
                                است
                            </p>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    );
};

export default LoginPage;
